import { Button, Input, Popover, Select, Switch } from "antd";
import { useBooking } from "./BookingContext";
import { useDebounce } from "rooks";
import { Close, Refine } from "../../components/Icons";
import { useEffect, useState } from "react";

const { Search } = Input;

export const filterItems = {
    new: {
        name: 'New Booking',
        tagColor: '#1890ff',
        color: 'processing',
        showFn: (r) => r.status === 'new',
    },
    accepted: {
        name: 'Booking Confirmed',
        tagColor: '#52c41a',
        color: 'success',
        showFn: (r) => r.status === 'accepted',
    },
    scheduled: {
        name: 'Scheduled',
        tagColor: '#faad14',
        color: 'warning',
        showFn: (r) => r.status === 'scheduled',
    },
    allocated: {
        name: 'Allocated',
        tagColor: '#faad14',
        color: 'warning',
        showFn: (r) => r.status === 'allocated',
    },
    completed: {
        name: 'Completed',
        tagColor: '#52c41a',
        color: 'success',
        showFn: (r) => r.status === 'completed',
    },
    cancelled: {
        name: 'Cancelled',
        tagColor: '#ff4d4f',
        color: 'error',
        showFn: (r) => r.status === 'cancelled',
    },
};

export const quoteFilterItems = {
    draft: {
        name: 'Draft Quote',
        tagColor: '#52c41a',
        color: 'success',
        showFn: (r) => r.quoteStatus === 'draft',
    },
    sent: {
        name: 'Quote Sent',
        tagColor: '#52c41a',
        color: 'success',
        showFn: (r) => r.quoteStatus === 'sent',
    },
    accepted: {
        name: 'Quote Accepted',
        tagColor: '#52c41a',
        color: 'success',
        showFn: (r) => r.quoteStatus === 'accepted',
    },
    confirmed: {
        name: 'Quote Confirmed',
        tagColor: '#52c41a',
        color: 'success',
        showFn: (r) => r.quoteStatus === 'confirmed',
    },
    invoiceDraft: {
        name: 'Invoice Draft',
        tagColor: '#52c41a',
        color: 'success',
        showFn: (r) => r.quoteStatus === 'invoice-draft',
    },
    awaitingPayment: {
        name: 'Awaiting Payment',
        tagColor: '#52c41a',
        color: 'success',
        showFn: (r) => r.quoteStatus === 'awaiting-payment',
    },
    paid: {
        name: 'Paid',
        tagColor: '#52c41a',
        color: 'success',
        showFn: (r) => r.quoteStatus === 'paid',
    },
};

export const BookingFilters = () => {
    const {
        filterBy,
        setFilterBy,
        filter,
        setFilter,
    } = useBooking();

    const [searchTerm, setSearchTerm] = useState(filter);

    const setFilterDebounced = useDebounce(setFilter, 250);

    useEffect(() => {
        setFilterDebounced(searchTerm);
    }, [searchTerm]);

    return (
        <div className="d-flex align-items-center justify-content-between filter-options-main mb-0">
            <div>
                <div className="d-flex align-items-center" style={{ gap: 0 }}>
                    {filter || filterBy?.length ? (
                        <Button onClick={() => {
                            setSearchTerm('');
                            setFilter("");
                            setFilterBy([]);
                        }} type="primary" className="icon-button btn-filled icon-10 btn-xs"><Close/> Clear Filters</Button>
                    ) : (
                        <></>
                    )}
                    <div className="justify-content-end mr-4">
                        <Search
                            id="basic-addon1"
                            style={{
                                width: 180,
                            }}
                            value={searchTerm}
                            allowClear={true}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <Popover
                        placement="bottomRight"
                        trigger="click"
                        overlayClassName="filters-popover"
                        title={
                            <div className="d-flex justify-content-between align-items-center">
                                Filter settings
                                {/* {filter || filterBy?.length ? (
                                    <Button
                                        onClick={() => {
                                            setFilter("");
                                            setFilterBy([]);
                                        }}
                                        type="primary"
                                        className="icon-button btn-filled icon-10 btn-xs"
                                    >
                                        <Close /> Clear
                                    </Button>
                                ) : (
                                    <></>
                                )} */}
                            </div>
                        }
                        content={
                            <div className="filter-wrap">
                                <div className="filter-switches-sm mt-0">
                                    {Object.keys(filterItems).map((key) => {
                                        const filterItem = filterItems[key];
                                        return (
                                            <div key={`filter-switch-${filterItem.name}`}>
                                                <span>
                                                    <i style={{ background: filterItem.tagColor }} /> {filterItem.name}
                                                </span>{" "}
                                                <Switch
                                                    className="default-switch"
                                                    size="small"
                                                    checked={filterBy.includes(key)}
                                                    onChange={(checked) => {
                                                        setFilterBy((prevFilterBy) => {
                                                            if (checked) {
                                                                return [...prevFilterBy, key];
                                                            } else {
                                                                return prevFilterBy.filter(f => f !== key);
                                                            }
                                                        });
                                                    }}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        }
                    >
                        <Button type="primary" className={`icon-button inline-icon`}>
                            <Refine />
                            Filter
                        </Button>
                    </Popover>
                </div>
            </div>
        </div>
    );
}; 